const Routes = [
  {
    path: '/sellout_dashboard',
    name: 'SelloutDashboard',
    component: () => import('@/app/sellout_dashboard/TheSelloutDashboard'),
    redirect: '/sellout_dashboard/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/sellout_dashboard/views/Index')
      }
    ]
  }
]
export default Routes



// WEBPACK FOOTER //
// ./src/app/sellout_dashboard/Routes.js